import script from "./TcSwitch.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TcSwitch.vue?vue&type=script&lang=ts&setup=true"
export * from "./TcSwitch.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TcSwitch.vue?vue&type=script&lang=ts&setup=true"

import "./TcSwitch.vue.scss?vue&type=style&index=0&id=7e6807ce&lang=scss!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./TcSwitch.vue?vue&type=style&index=0&id=7e6807ce&lang=scss"

const __exports__ = script;

export default __exports__